<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Upload {{ title }} files to OpenAI</v-card-title>
            <v-card-text class="justify-center pa-0" v-for="file in files" :key="file.filename">
                <v-divider></v-divider>
                <v-row class="pa-2 ma-0">
                    <v-col cols=12 class="justify-center pa-2">
                        <v-btn color="primary" small :disabled="disableAll!==0" @click="uploadFile([file])">Upload {{ file.description }}</v-btn>
                        <span class="px-4" v-if="file.filename in file_info">Last upload: {{ file_info[file.filename].created_date.replace("T", " at ") }}</span>
                        <span class="px-4" v-else>File not yet uploaded</span>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="disableAll!==0" @click="uploadAll">Upload all files</v-btn>
                
                <v-btn color="primary" small :disabled="disableAll!==0" @click="closeDialog">Done</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
            title: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                dialog: false,
                files: [],
                file_info: {},
                disableAll: 0,
            }
        },
        methods: { 
            openDialog(files) {
                this.files = files;
                this.getFileInfo();
            },
            getFileInfo() {
                this.$axios.post("ares/json/ares/syst/openai/getOpenAIFiles.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getOpenAIFiles",
                    },
                    getOpenAIFiles: this.files,
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // this.$store.dispatch("setSnackbar", {
                        //     showing: true,
                        //     text: res.data.error.message,
                        //     color: "error",
                        // });
                    } else {
                        this.file_info = res.data.getOpenAIFiles;
                        this.dialog = true;
                    }
                });

            },
            closeDialog() {
                this.dialog = false;
            },
            uploadAll() {
                this.uploadFile(this.files);
            },
            uploadFile(files) {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/uploadFileList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "uploadOpenAIFile",
                    },
                    uploadOpenAIFile: files,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                        this.$refs.showProgress.close();
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.uploadOpenAIFile.text,
                            color: res.data.uploadOpenAIFile.color,
                        });
                        this.disableAll -= 1;
                        this.getFileInfo();
                    }
                });
            },
        }
    }
</script>